import moment from 'moment-timezone'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Timeline } from 'antd'
import { ImDfmStateType } from '@Admin/AdminQuotingPage/ImDfmSlidesPanel/ImDfmSlide/constants'

import Box from '~/core/Box'
import Text from '~/core/Text'
import { getUserIdentity } from '~/redux-modules/identity'
import { FICTIV_HELP_EMAIL } from '~/lib/appRegionConstants'
import { ActivityType } from '../index'
import ActivityLogNote from '../ActivityLogNote'

import { getFileNamesForQmrPricedLog, getLogActivity } from './logic'

const FICTIV_USER = 'Fictiv'
const FICTIV_USER_EMAIL = 'admin@fictiv.com'
const CPQ_USER_EMAIL = 'cpq.api.user@fictiv.com'

type ActivityLogItemPropsType = {
    activityItem: ActivityType
    key: string
}

const ActivityLogItem = (props: ActivityLogItemPropsType) => {
    const {
        activityItem: { actor, createdAt, meta, quote, summary, targetId },
        key,
    } = props

    const identity = useSelector(getUserIdentity)
    const { userId: isLocatedInObo = '' } = useParams<{
        userId?: string
    }>()

    const metaParsed: {
        recipientEmail: string
        note: string
        partName: string
        topicLabel: string
        dfmTopicLabel: string
        dfmStatus: ImDfmStateType
        fileName: string
        operation: string
        description: string
        sourceType: string
        changeType: string[]
        changeDescription: string
        isUnlockedForDesignChange: boolean
    } = meta ? JSON.parse(meta) : {}

    let email = actor?.email || ''

    // The activity log api will redact the Fictiv employee email address when:
    //      * Fictiv employee is in OBO mode
    //      * Customer viewing their activity log where Fictiv employees have taken action
    const isFictivEmployeeEmailRedacted = email === FICTIV_HELP_EMAIL
    const isCustomerView = !identity?.isAdmin && !isLocatedInObo
    const isAdminOboView = identity.isAdmin && isLocatedInObo
    const isAdmin = identity.isAdmin
    let isActionPerformedByCpq = false

    if (email == CPQ_USER_EMAIL) {
        isActionPerformedByCpq = true
    }

    if (isFictivEmployeeEmailRedacted && (isCustomerView || isAdminOboView)) {
        email = FICTIV_USER
    }

    if (isAdmin && !isAdminOboView && email == '') {
        email = FICTIV_USER_EMAIL
    }

    const date = moment(createdAt).format(`ddd, MMM Do YYYY, hh:mm A`)

    let qmrPricedFileNames: (string | undefined)[] = []

    qmrPricedFileNames = getFileNamesForQmrPricedLog(
        quote.quoteItems?.items,
        summary,
        targetId,
    )

    const activity = getLogActivity(
        summary,
        metaParsed?.partName,
        metaParsed?.topicLabel,
        metaParsed?.dfmTopicLabel,
        qmrPricedFileNames,
        metaParsed?.dfmStatus,
        metaParsed?.note,
        metaParsed?.recipientEmail,
        metaParsed?.fileName,
        metaParsed?.operation,
        metaParsed?.description,
        metaParsed?.sourceType,
        metaParsed?.changeType,
        metaParsed?.changeDescription,
        metaParsed?.isUnlockedForDesignChange,
        isActionPerformedByCpq,
    )

    return (
        <Timeline.Item
            key={key}
            style={{
                margin: '0px 14px',
            }}
        >
            <Box color="blackAlpha45">{date}</Box>
            {!isActionPerformedByCpq && (
                <Text color="success" fontWeight={500}>
                    {email}{' '}
                </Text>
            )}
            {activity}
            {metaParsed?.note && <ActivityLogNote note={metaParsed?.note} />}
        </Timeline.Item>
    )
}

export default ActivityLogItem
